import { useEffect } from 'react'

import { useParams } from 'react-router-dom'

import { useGetMetaAdsCampaignByIdQuery } from 'src/Redux/adsCampaignApi'
import { useScheduleEvents } from 'src/Hooks/useScheduleEvents'
import { CampaignPlatformTypeEnum, CampaignTypeEnum } from 'src/Types/campaigns'

export const useScheduleStartEvent = (): void => {
  const { number: campaignIdParams } = useParams()
  const { data: campaignDetails } = useGetMetaAdsCampaignByIdQuery(
    Number(campaignIdParams),
  )

  const { handleScheduleStartEvent } = useScheduleEvents()
  const campaignId = campaignDetails?.id

  const campaignType = CampaignTypeEnum.BASIC

  const campaignGenres = campaignDetails?.genres
    ?.map((genre) => genre)
    .join(', ')

  useEffect(() => {
    if (String(campaignId) !== String(campaignIdParams)) {
      return
    }

    handleScheduleStartEvent({
      campaignType,
      platformName: CampaignPlatformTypeEnum.META,
      campaignId: Number(campaignId),
      genreList: campaignGenres,
    })
  }, [
    handleScheduleStartEvent,
    campaignDetails,
    campaignId,
    campaignIdParams,
    campaignType,
    campaignGenres,
  ])
}
